import { LitElement, html } from 'lit';
import { customElement, state } from 'lit/decorators.js';

@customElement('sort-by-filter')
export class SortByFilter extends LitElement {
  createRenderRoot() { return this }
  @state() sort = 'hot';
  @state() timeframe = 'week';

  private emitFilterChange() {
    this.dispatchEvent(new CustomEvent('filter-change', {
      detail: {
        sort: this.sort,
        timeframe: this.timeframe
      },
      bubbles: true,
      composed: true
    }));
  }

  render() {
    return html`
      <div class="flex items-center gap-2">
        <select class="select select-sm" 
          @change=${e => {
            this.sort = e.target.value;
            this.emitFilterChange();
          }}
        >
          <option value="hot" ?selected=${this.sort === 'hot'}>Hot</option>
          <option value="new" ?selected=${this.sort === 'new'}>New</option>
          <option value="top" ?selected=${this.sort === 'top'}>Top</option>
        </select>

        ${this.sort === 'top' ? html`
          <select class="select select-sm"
            @change=${e => {
              this.timeframe = e.target.value;
              this.emitFilterChange();
            }}
          >
            <option value="today">Today</option>
            <option value="week" selected>Week</option>
            <option value="month">Month</option>
            <option value="year">Year</option>
            <option value="all">All Time</option>
          </select>
        ` : null}
      </div>
    `;
  }
}
